"use client";

import { Dialog, DialogCloseButton } from "@cappelendamm/design-system/react";
import { useRef, type ReactNode } from "react";
import { Xmark } from "iconoir-react";

type BookClubTermsDialogProps = {
  children: ReactNode;
  triggerText?: string;
};

export function BookClubTermsDialog({
  children,
  triggerText = "Les om vilkårene for bokklubb",
}: BookClubTermsDialogProps) {
  const dialog = useRef<HTMLDialogElement>(null);

  return (
    <>
      <button
        type="button"
        onClick={() => dialog.current?.showModal()}
        className="font-medium underline underline-offset-2"
      >
        {triggerText}
      </button>
      <Dialog
        ref={dialog}
        aria-label={triggerText}
        className="grid-cols-[1fr_auto] content-start gap-4 open:grid sm:inset-0 sm:m-auto sm:min-w-[min(75dvw,65ch)] sm:content-normal"
      >
        <DialogCloseButton
          onClick={() => {
            if (dialog.current) dialog.current.close();
          }}
          className="absolute top-4 right-4 z-10"
        >
          <Xmark width={24} height={24} />
        </DialogCloseButton>
        <article className="prose pt-8 md:p-8">{children}</article>
      </Dialog>
    </>
  );
}
